import { all, put, take } from 'redux-saga/effects';

import { PIPEROUTER__TOC } from 'PipeRouter';
import { SAVE_ANNOTATIONS } from './actions';
import { SAVE_BOOKMARKS, SAVE_HIGHLIGHTS, SAVE_NOTES } from 'Reducers/dataModels';


function* saveAnnotations() {
  const { data:annotations } = yield take(SAVE_ANNOTATIONS);
  const [bookmarks, highlightsAndNotes] = annotations;

  yield all([
    put({ type: SAVE_BOOKMARKS, data: bookmarks }),
    put({ type: SAVE_HIGHLIGHTS, data: highlightsAndNotes[0] }),
    put({ type: SAVE_NOTES, data: highlightsAndNotes[1] })
  ]);
}


export default saveAnnotations;
